<template>
  <div class="d-flex flex-row flex-wrap pa-3 font-16">
    <div class="col-12 pb-0 mt-3">
      <p class="font-weight-bold font-20 black2-color">
        Are you sure you want to save and exit?
      </p>
      <p v-if="showUserRef">
        You can enter a reference below if you would like to.
      </p>
      <p
        v-if="sectionReminder"
        class="mt-8 mb-11 font-20 black2-color section-remider-text"
      >
        {{ sectionReminder }}
      </p>
      <ValidationObserver v-slot="{ passes }">
        <form @submit.prevent="passes(onSubmit)">
          <v-row>
            <v-col>
              <BaseInput
                v-if="showUserRef"
                v-model="reference"
                vid="reference"
                label="Reference"
                name="reference"
                fieldName="Reference"
                class="mt-4"
                :rules="{
                  max: {
                    length: 40,
                    fieldLabel: 'Reference',
                  },
                  regex: {
                    pattern: USER_REF_EXCLUDE_ANGLE_BRACKETS_REGEX,
                    customMessage: ERROR_MSG_USER_REF,
                  },
                }"
                :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" class="text-center pb-1">
              <BaseButton
                text="SAVE & EXIT"
                depressed
                rounded
                :width="$vuetify.breakpoint.lgAndUp ? '420' : '100%'"
                height="60"
                :color="'psorange'"
                class="font-20 font-weight-bold save-exit-button"
                type="submit"
              />
            </v-col>
            <v-col cols="12" class="text-center"
              ><a
                class="font-18 black-color text-decoration-underline"
                @click="$emit('close')"
                >Cancel</a
              ></v-col
            >
          </v-row>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import BaseInput from "@/components/BaseComponents/BaseInput.vue";
import BaseButton from "@/components/BaseComponents/BaseButton.vue";
import { mapState } from "vuex";
import { QUESTIONS_MODULE } from "@/store/types/module-types";
import { ValidationObserver } from "vee-validate";
import { USER_REF_EXCLUDE_ANGLE_BRACKETS_REGEX } from "@/constants/regex-patterns.constants";
import { ERROR_MSG_USER_REF } from "@/constants/message.constants";

export default {
  name: "SaveAndExit",
  components: {
    BaseInput,
    BaseButton,
    ValidationObserver,
  },
  props: {
    showUserRef: {
      type: Boolean,
      default: true,
    },
    sectionReminder: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      reference: "",
      USER_REF_EXCLUDE_ANGLE_BRACKETS_REGEX,
      ERROR_MSG_USER_REF,
    };
  },
  computed: {
    ...mapState(QUESTIONS_MODULE, ["userReference"]),
  },
  mounted() {
    this.reference = this.userReference;
  },
  watch: {
    userReference(value) {
      this.reference = value;
    },
  },
  methods: {
    onSubmit() {
      this.$emit("saveAndExit", this.reference);
    },
  },
};
</script>

<style lang="scss" scoped>
footer {
  .v-btn {
    &.v-size--x-large {
      color: $black-2;
      height: 60px !important;
    }
  }
}

// xs breakpoint
@media screen and (max-width: 600px) {
  footer {
    .v-btn {
      &.v-size--x-large {
        margin-top: 26px;
        width: 100%;
      }
    }
  }
}

// sm breakpoint plus
@media screen and (min-width: 600px) {
  footer {
    .v-btn {
      &.v-size--x-large {
        margin-top: 30px;
        max-width: 420px;
        width: 100%;
      }
    }
  }
}
</style>
